module.exports = __webpack_public_path__ + "static/img/34.a66a2376.png";